module.exports = __webpack_public_path__ + "static/media/google.3e26049d.png";